export const DEAL_EVENT_NAMES = new Set([
  "deal_created",
  "deal_updated",
  "deal_stage_changed",
  "deal_won",
  "deal_lost",
  "deal_assignee_changed",
]);

export const isDealEvent = (eventName) => DEAL_EVENT_NAMES.has(eventName);

export const eventOptions = [
  {
    value: "deal_created",
    label: "Negocio criado",
    group: "Eventos de negocio",
  },
  {
    value: "deal_updated",
    label: "Negocio atualizado",
    group: "Eventos de negocio",
  },
  {
    value: "deal_stage_changed",
    label: "Estagio alterado",
    group: "Eventos de negocio",
  },
  { value: "deal_won", label: "Negocio ganho", group: "Eventos de negocio" },
  { value: "deal_lost", label: "Negocio perdido", group: "Eventos de negocio" },
  {
    value: "deal_assignee_changed",
    label: "Responsavel alterado",
    group: "Eventos de negocio",
  },
  {
    value: "conversation_created",
    label: "Conversa criada",
    group: "Eventos de conversa",
  },
  {
    value: "conversation_updated",
    label: "Conversa atualizada",
    group: "Eventos de conversa",
  },
  {
    value: "conversation_resolved",
    label: "Conversa resolvida",
    group: "Eventos de conversa",
  },
  {
    value: "message_created",
    label: "Mensagem criada",
    group: "Eventos de conversa",
  },
  {
    value: "conversation_opened",
    label: "Conversa aberta",
    group: "Eventos de conversa",
  },
];

export const queryOperatorOptions = [
  { value: "AND", label: "E (AND)" },
  { value: "OR", label: "OU (OR)" },
];

export const operatorOptions = {
  equal_to: { value: "equal_to", label: "Igual a" },
  not_equal_to: { value: "not_equal_to", label: "Diferente de" },
  contains: { value: "contains", label: "Contem" },
  does_not_contain: { value: "does_not_contain", label: "Nao contem" },
  is_present: { value: "is_present", label: "Esta preenchido" },
  is_not_present: { value: "is_not_present", label: "Nao esta preenchido" },
  is_greater_than: { value: "is_greater_than", label: "Maior que" },
  is_less_than: { value: "is_less_than", label: "Menor que" },
};

export const conditionSchema = {
  pipeline_id: {
    label: "Pipeline",
    inputType: "select_pipeline",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  pipeline_stage_id: {
    label: "Estagio do pipeline",
    inputType: "select_stage",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  status: {
    label: "Status do negocio",
    inputType: "select_status",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  assignee_id: {
    label: "Responsavel",
    inputType: "select_assignee",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  amount: {
    label: "Valor",
    inputType: "number",
    operators: [
      "equal_to",
      "not_equal_to",
      "is_greater_than",
      "is_less_than",
      "is_present",
      "is_not_present",
    ],
  },
  currency: {
    label: "Moeda",
    inputType: "text",
    operators: ["equal_to", "not_equal_to", "contains", "does_not_contain"],
  },
  priority: {
    label: "Prioridade",
    inputType: "select_priority",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  deal_loss_reason_id: {
    label: "Motivo de perda",
    inputType: "select_loss_reason",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  contact_id: {
    label: "Contato",
    inputType: "number",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  conversation_id: {
    label: "Conversa",
    inputType: "number",
    operators: ["equal_to", "not_equal_to", "is_present", "is_not_present"],
  },
  close_date: {
    label: "Data de fechamento",
    inputType: "datetime",
    operators: [
      "equal_to",
      "not_equal_to",
      "is_greater_than",
      "is_less_than",
      "is_present",
      "is_not_present",
    ],
  },
  created_at: {
    label: "Data de criacao",
    inputType: "datetime",
    operators: [
      "equal_to",
      "not_equal_to",
      "is_greater_than",
      "is_less_than",
      "is_present",
      "is_not_present",
    ],
  },
  updated_at: {
    label: "Data de atualizacao",
    inputType: "datetime",
    operators: [
      "equal_to",
      "not_equal_to",
      "is_greater_than",
      "is_less_than",
      "is_present",
      "is_not_present",
    ],
  },
};

export const conditionAttributeOptions = Object.entries(conditionSchema).map(
  ([value, config]) => ({
    value,
    label: config.label,
  }),
);

export const actionSchema = {
  assign_agent: { label: "Atribuir responsavel" },
  change_stage: { label: "Mover para estagio" },
  change_status: { label: "Alterar status" },
  change_priority: { label: "Alterar prioridade" },
  mark_as_lost: { label: "Marcar como perdido" },
  add_note: { label: "Adicionar anotacao" },
  create_activity: { label: "Criar atividade" },
  send_webhook_event: { label: "Enviar webhook" },
};

export const actionOptions = Object.entries(actionSchema).map(
  ([value, config]) => ({
    value,
    label: config.label,
  }),
);

export const statusOptions = [
  { value: "open", label: "Aberto" },
  { value: "won", label: "Ganho" },
  { value: "lost", label: "Perdido" },
];

export const actionStatusOptions = statusOptions.filter(
  (option) => option.value !== "lost",
);

export const priorityOptions = [
  { value: "", label: "Sem prioridade" },
  { value: "urgent", label: "Urgente" },
  { value: "high", label: "Alta" },
  { value: "medium", label: "Media" },
  { value: "low", label: "Baixa" },
];

export const getOptionLabel = (options, value, fallback = "-") => {
  const found = options.find((option) => option.value === value);
  return found?.label || value || fallback;
};

export const getConditionOperatorOptions = (attributeKey) => {
  const operators = conditionSchema[attributeKey]?.operators || ["equal_to"];
  return operators.map((key) => operatorOptions[key]).filter(Boolean);
};

export const shouldHideValueInput = (operator) =>
  ["is_present", "is_not_present"].includes(operator);
